import React from "react";
import { bindActionCreators } from "redux";
import { getModule, getModules, isModuleStateEqual } from "Redux/Query";
import { findModulesRequest } from "Redux/Action";
import { connect } from "react-redux";
import Select, { Option } from "Common/Select/Select";
import { Subject} from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";
import isEmpty from "lodash/isEmpty";

class ModuleSelect extends React.Component {

    state = {
        activeModule: null,
    };

    onSearch$   = new Subject();
    onDestroy$  = new Subject();


    componentDidMount() {
        this.onSearch$.pipe(takeUntil( this.onDestroy$ ), debounceTime( 500 )).subscribe((value) => {
            const filterProps = {
                sorting: { field: '`Module`.`name`', order: 'ASC' },
                pagination: { page: 1, take: 25 }
            }
            if(!value || `${value}`.trim() === '') {
                return this.props.findModulesRequest(filterProps);
            }

            this.props.findModulesRequest({
                filter: [{ field: '`Module`.`name`', value: `%${value}%` }],
                ...filterProps,
            })
        });

        this.onSearch$.next();
    }

     componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.value && this.props.value !== prevProps.value) {
            this.setState(() => ({ activeModule: this.props.value }));
        }
     }

    componentWillUnmount() {
        this.onDestroy$.next();
        this.onDestroy$.complete();

    }

    handleOnSearchModule = (value) => {
        this.onSearch$.next(value);
    };

    handleOnChangeModule = ( moduleId ) => {
        const activeModule = { ...(this.props.getModule(moduleId) ?? { id: moduleId }) }
        this.setState(
            () => ({ activeModule }),
            () => {
                if(this.props.hasOwnProperty('onChange') && typeof this.props.onChange === 'function') {
                    this.props.onChange( activeModule )
                }
            }
        );
    };

    render() {
        return(
            <React.Fragment>
                <div className="label">Verfahren auswählen</div>
                <Select
                    defaultValue={ this.props.defaultValue ? this.props.defaultValue.id : null }
                    value={ this.props.value?.id || this.state.activeModule?.id }
                    showSearch
                    placeholder="Modul"
                    defaultActiveFirstOption={ false }
                    filterOption={ false }
                    suffixIcon={ false }
                    notFoundContent={ null }
                    onSearch={ this.handleOnSearchModule }
                    onChange={ this.handleOnChangeModule }
                >
                    <Option value={ null } key={ `no_module` }>-- Verfahren --</Option>
                    { this.props.allowAll && <Option value={ 'all' } key={ `all_modules` }>Alle Verfahren</Option> }
                    { this.props.modules.map( module =>
                        <Option value={ module.id } key={ module.id }>{ module.name }</Option>)
                    }
                </Select>

            </React.Fragment>
        );
    }

}


function mapStateToProps(state, props) {
    const modules   = getModules(state);
    const moduleIds = modules.map(module => module.id);
    if(!isEmpty(props.defaultValue) && !moduleIds.includes(props.defaultValue.id)) {
        moduleIds.unshift(props.defaultValue);
    }
    return {
        modules,
        getModule: (id) => getModule(state, id),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            findModulesRequest,
        },
        dispatch,
    )
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    return Object.assign({}, ownProps, stateProps, dispatchProps);
};

const options = {
    areStatesEqual: (nextStore, prevStore) => {
        return (
            isModuleStateEqual(nextStore, prevStore)
        );
    }
};


export default connect( mapStateToProps, mapDispatchToProps, mergeProps, options)(ModuleSelect);
